import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onDragstart", "onDragend", "onDragenter", "onDragleave", "onDrop"]
const _hoisted_4 = {
  class: "dropdown",
  style: {"position":"absolute","right":"40px"}
}
const _hoisted_5 = {
  role: "menu",
  class: "dropdown-menu dropdown-menu-right"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-ellipsis fg-color-gray" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-ellipsis fg-color-gray1" }
const _hoisted_16 = {
  key: 0,
  class: "CriterionDragHandler",
  title: "Click and hold to drag criterion"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionCreator = _resolveComponent("CriterionCreator")!
  const _component_CriterionEditor = _resolveComponent("CriterionEditor")!
  const _component_CriterionDeleter = _resolveComponent("CriterionDeleter")!
  const _component_AttributeLibrary = _resolveComponent("AttributeLibrary")!
  const _component_CriteriaFromStringBuilder = _resolveComponent("CriteriaFromStringBuilder")!
  const _component_CriteriaLibrary = _resolveComponent("CriteriaLibrary")!
  const _component_ScaleTemplateViewer = _resolveComponent("ScaleTemplateViewer")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_GoalNavigation = _resolveComponent("GoalNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionCreator, {
      viewModel: _ctx.criterionCreator,
      onCreateCriterion: _ctx.handleCreateCriterionCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateCriterion"]),
    _createVNode(_component_CriterionEditor, {
      viewModel: _ctx.criterionEditor,
      onDeleteCriterion: _ctx.showCriterionDeleter,
      onUpdateCriterion: _ctx.handleUpdateCriterionCommand
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteCriterion", "onUpdateCriterion"]),
    _createVNode(_component_CriterionDeleter, {
      viewModel: _ctx.criterionDeleter,
      onDeleteCriterion: _ctx.handleDeleteCriterionCommand
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteCriterion"]),
    _createVNode(_component_AttributeLibrary, {
      viewModel: _ctx.attributeLibrary,
      onCreateCriterion: _ctx.handleCreateCriterionFromAttributeCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateCriterion"]),
    _createVNode(_component_CriteriaFromStringBuilder, {
      viewModel: _ctx.criteriaFromStringBuilder,
      onCreateCriteria: _ctx.handleCreateCriteriaFromStringCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateCriteria"]),
    _createVNode(_component_CriteriaLibrary, {
      viewModel: _ctx.criteriaLibrary,
      onCreateCriterion: _ctx.handleCreateCriterionFromTemplateCommand,
      onShowScale: _ctx.showScaleTemplateViewer
    }, null, 8 /* PROPS */, ["viewModel", "onCreateCriterion", "onShowScale"]),
    _createVNode(_component_ScaleTemplateViewer, { viewModel: _ctx.scaleTemplateViewer }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onDragover: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"]))
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("a", {
              class: "btn btn-outline-secondary float-right",
              href: "https://www.transparentchoice.com/user-guide/build-criteria",
              title: "User guide: Build criteria",
              target: "_blank"
            }, [
              _createElementVNode("i", {
                class: "fa fa-info",
                "aria-hidden": "true"
              })
            ], -1 /* CACHED */)),
            _createElementVNode("h3", null, " Goal: " + _toDisplayString(_ctx.goalName), 1 /* TEXT */),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createVNode(_component_GoalNavigation, {
              ActivePage: "criteria-hierarchy",
              WorkspaceId: _ctx.workspaceId,
              ProjectId: _ctx.projectId,
              EvalModelId: _ctx.evalModelId,
              ScoringEnabled: _ctx.ScoringEnabled
            }, null, 8 /* PROPS */, ["WorkspaceId", "ProjectId", "EvalModelId", "ScoringEnabled"]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "alert alert-info alert-dismissible" }, [
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "alert",
                "aria-hidden": "true"
              }, "×"),
              _createElementVNode("p", null, "Use this screen to create your criterion hierarchy. To create a new criterion, simply click on the gear-wheel.")
            ], -1 /* CACHED */)),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criteriaView, (vm) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: vm.CriterionId,
                  style: _normalizeStyle({ 'marginLeft': vm.Level*50 + 'px', cursor: _ctx.isDragEnabled(vm.CriterionId) ? 'move' : 'default' })
                }, [
                  _createElementVNode("div", {
                    class: "Criterion",
                    draggable: "true",
                    onDragstart: ($event: any) => (_ctx.onDragStart($event, vm)),
                    onDragend: ($event: any) => (_ctx.onDragEnd($event, vm)),
                    onDragenter: ($event: any) => (_ctx.onDragEnter($event, vm)),
                    onDragleave: ($event: any) => (_ctx.onDragLeave($event, vm)),
                    onDrop: ($event: any) => (_ctx.onDrop($event, vm))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["tile", { 'CriterionHovered': vm.DragOver }])
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[4] || (_cache[4] = _createElementVNode("a", {
                          class: "text-dark",
                          "data-toggle": "dropdown"
                        }, [
                          _createElementVNode("i", { class: "fa fa-cog fa-lg" })
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showCriterionEditor(vm))
                          }, "Edit", 8 /* PROPS */, _hoisted_6),
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showCriterionCreator(vm))
                          }, "Add sub-criterion", 8 /* PROPS */, _hoisted_7),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showCriteriaFromStringBuilder(vm))
                          }, "Add many", 8 /* PROPS */, _hoisted_8),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showAttributeLibrary(vm))
                          }, "Add from attributes", 8 /* PROPS */, _hoisted_9),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showCriteriaLibrary(vm))
                          }, "Add from criterion library", 8 /* PROPS */, _hoisted_10),
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          (!_ctx.isGoal(vm.CriterionId))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showCriterionDeleter(vm.CriterionId))
                              }, "Delete", 8 /* PROPS */, _hoisted_11))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "pointer",
                        onClick: ($event: any) => (_ctx.showCriterionEditor(vm))
                      }, [
                        _createElementVNode("h5", _hoisted_13, [
                          (_ctx.hasSubCriteria(vm.CriterionId))
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(vm.IsCollapsed ? 'fa fa-folder' : 'fa fa-folder-open'),
                                onClick: _withModifiers(($event: any) => (vm.IsCollapsed = !vm.IsCollapsed), ["stop"])
                              }, null, 10 /* CLASS, PROPS */, _hoisted_14))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("span", null, _toDisplayString(vm.Name), 1 /* TEXT */)
                        ]),
                        _createElementVNode("small", _hoisted_15, _toDisplayString(vm.Description || ' '), 1 /* TEXT */),
                        (_ctx.isDragEnabled(vm.CriterionId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                          : _createCommentVNode("v-if", true)
                      ], 8 /* PROPS */, _hoisted_12)
                    ], 2 /* CLASS */)
                  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_3)
                ], 4 /* STYLE */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 32 /* NEED_HYDRATION */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}